import axios from 'axios';
import { propertyHitAccess, mapaprop } from '@/environment'
const propertyHit = async (custId: any, propertyId:any , currentUrl:any ) => {
	try {
		const apiUrl = propertyHitAccess.baseURL;
		const headers = {
			'Content-Type': 'text/plain',
			Authorization: 'Bearer ' + mapaprop.token,
		};
		const data = {
			custId: custId,
			propertyId: propertyId,
			brandId: 'mapaprop',
			origin: 'MartillerosUnidos',
			originUrlHit: currentUrl,
			brandCountry: 'ar',
		};
		const response = await axios.put(apiUrl, data, { headers });
	//	console.log('Respuesta de la solicitud PUT:', response.data);
	} catch (error) {
		//console.error('Error al realizar la solicitud PUT:', error);
	}
};
export { propertyHit };
